import { IWprViewProps } from '../props/IWprViewProps';
import { WprBaseViewCoreComponent } from './WprBaseViewCoreComponent';

/**
 * ビューコンポーネント基本クラス
 */
export abstract class WprBaseViewComponent extends WprBaseViewCoreComponent<IWprViewProps> {
}
